import React, { useContext } from 'react'
import { Redirect } from 'react-router-dom'
import { AbilityContext } from '@app/context/ability-context'
import { statePath } from '@app/helpers/studentsHelper'

const Home = (props) => {
  const ability = useContext(AbilityContext)
  return ( <Redirect to={statePath(ability)} /> )
}

export default Home
